import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UserType } from '../../../shared/enum';
import { toggleEditMode } from '../../../shared/utils';
import { IOffertBase } from '../../models/offertbase';
import { PopupService } from '../../service/popup.service';
import { UserStatusService } from '../../service/user.status.service';

@Component({
  selector: 'app-daten-beratungsprotokoll',
  templateUrl: './daten-beratungsprotokoll.component.html',
  styleUrls: ['./daten-beratungsprotokoll.component.scss']
})
export class DatenBeratungsprotokollComponent implements OnInit {
  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  antrag: boolean;

  @Input()
  expertMode: boolean;

  @Input()
  showHeadLine = true;

  constructor(public translateService: TranslateService, public popupService: PopupService, private userStatusService: UserStatusService) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      beratungsprotokoll: new UntypedFormControl('')
    });
  }

  ngOnInit(): void {
    this.toggleEditMode();
  }

  get beratungsprotokoll() { return this.formGroup.get('beratungsprotokoll'); }

  get showDatenBeratungsprotokoll() {
    return this.expertMode === true && this.userStatusService.userStatus.UserType !== UserType.Mitarbeiter;
  }

  toggleEditMode(): void {
    toggleEditMode(this.beratungsprotokoll, this.showDatenBeratungsprotokoll);
  }

  getOffertBase(): IOffertBase {
    return {
      Beratungsprotokoll: this.beratungsprotokoll.value ?
        this.beratungsprotokoll.value === 'ja' ? true : false : null,
    } as IOffertBase;
  }

  setOffertBase(offertBase: IOffertBase) {
    this.beratungsprotokoll.setValue(offertBase.Beratungsprotokoll === true ? 'ja' : 'nein');
  }
}
